import { FieldValues } from "react-hook-form";

import { I18nKeyType } from "@/i18n";

import { BaseFormInputPropsType, VnFormInput } from "../VnForm";
import {
  BaseDatePickerInput,
  BaseDatePickerInputPropsType,
} from "./BaseDatePickerInput";

type VnDatePickerInputPropsType<T extends FieldValues> =
  BaseFormInputPropsType<T> &
    Omit<BaseDatePickerInputPropsType, "onChange"> & {
      placeholderI18nKey?: I18nKeyType;
      placeholderI18nOptions?: object;
      inputClassName?: string;
    };

export const VnDatePickerInput = <T extends FieldValues>({
  placeholderI18nKey = "common:datePicker.placeholder",
  placeholderI18nOptions,
  inputClassName,
  ...props
}: VnDatePickerInputPropsType<T>) => {
  return (
    <VnFormInput {...props}>
      {({ field, hasError }) => (
        <BaseDatePickerInput
          i18nKey={placeholderI18nKey}
          i18nOptions={placeholderI18nOptions}
          className={inputClassName}
          hasError={hasError}
          {...field}
          {...props}
        />
      )}
    </VnFormInput>
  );
};
